import { render } from "./SalesByLocations.vue?vue&type=template&id=2396bb3c&ts=true"
import script from "./SalesByLocations.vue?vue&type=script&lang=ts"
export * from "./SalesByLocations.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__